import { z } from 'zod';
/** Route params for the endpoints addressing a single api instance. */
export const ApiInstanceIdParamsSchema = z.object({ apiInstanceId: z.uuid() }).strict();
//# sourceMappingURL=params.js.map